/* eslint-disable camelcase */
import AppSite from "./CreateOrEdit/SubModules/AppSite";
import CTVChannel from "./CreateOrEdit/SubModules/CtvChannels";
import Environment from "./CreateOrEdit/SubModules/Environment";
import Exchange from "./CreateOrEdit/SubModules/Exchange";
import Geo from "./CreateOrEdit/SubModules/Geo";
import Platform from "./CreateOrEdit/SubModules/Platform";
import Segment from "./CreateOrEdit/SubModules/Segment";
import Time from "./CreateOrEdit/SubModules/Time";
import {
  SUBMODULES,
  TARGETING_EXPRESSION_MODULES_DEFAULT_VALUES,
  VERB_USAGE,
} from "./targetingExpression.constant";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import RemoveCircleRoundedIcon from "@mui/icons-material/RemoveCircleRounded";
import StarsRoundedIcon from "@mui/icons-material/StarsRounded";
import WebAssetRoundedIcon from "@mui/icons-material/WebAssetRounded";
// import ImageRoundedIcon from '@mui/icons-material/ImageRounded';
import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import ComputerRoundedIcon from "@mui/icons-material/ComputerRounded";
import QueryBuilderRoundedIcon from "@mui/icons-material/QueryBuilderRounded";
import PersonRoundedIcon from "@mui/icons-material/PersonRounded";
import ShuffleRoundedIcon from "@mui/icons-material/ShuffleRounded";
import LibraryBooksRoundedIcon from "@mui/icons-material/LibraryBooksRounded";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import CustomSegment from "./CreateOrEdit/SubModules/CustomSegment";
import { LINE_ITEM_TYPE } from "@/modules/Campaign/GeneralCampaign/DetailCampaign/data";
import { SubModuleListItem } from "./targetingExpression.interface";

export const subModuleItemsList = (
  lineItemType?: string
): SubModuleListItem[] => {
  const baseItems = [
    {
      id: 0,
      label: "Audiences",
      value: SUBMODULES.CUSTOM_SEGMENT,
      icon: PersonOutlinedIcon,
    },
    {
      id: 3,
      label: "Exchange",
      value: SUBMODULES.EXCHANGE,
      icon: ShuffleRoundedIcon,
    },
    {
      id: 4,
      label: "Geo",
      value: SUBMODULES.GEO,
      icon: LocationOnRoundedIcon,
    },
    {
      id: 5,
      label: "Environment",
      value: SUBMODULES.ENVIRONMENT,
      icon: LibraryBooksRoundedIcon,
    },
    {
      id: 6,
      label: "Platform",
      value: SUBMODULES.PLATFORM,
      icon: ComputerRoundedIcon,
    },
    {
      id: 7,
      label: "Time",
      value: SUBMODULES.TIME,
      icon: QueryBuilderRoundedIcon,
    },
    {
      id: 8,
      label: "Segments",
      value: SUBMODULES.SEGMENT,
      icon: PersonRoundedIcon,
    },
  ];

  if (lineItemType === LINE_ITEM_TYPE.CTV) {
    return [
      {
        id: 1,
        label: "CTV Channels",
        value: SUBMODULES.CTV_CHANNEL,
        icon: WebAssetRoundedIcon,
      },
      ...baseItems,
    ];
  } else
    return [
      {
        id: 2,
        label: "App/Site",
        value: SUBMODULES.APP_SITE,
        icon: WebAssetRoundedIcon,
      },
      ...baseItems,
    ];
};
export const subModuleDetailPage = {
  [SUBMODULES.CTV_CHANNEL]: CTVChannel,
  [SUBMODULES.APP_SITE]: AppSite,
  [SUBMODULES.EXCHANGE]: Exchange,
  [SUBMODULES.ENVIRONMENT]: Environment,
  [SUBMODULES.GEO]: Geo,
  [SUBMODULES.PLATFORM]: Platform,
  [SUBMODULES.TIME]: Time,
  [SUBMODULES.SEGMENT]: Segment,
  [SUBMODULES.CUSTOM_SEGMENT]: CustomSegment,
};

export const dataCategory = [
  {
    label: "Include",
    value: "include",
  },
  {
    label: "Exclude",
    value: "exclude",
  },
];

export const defaultValuesTargetingPreset = (
  beeswaxAdvertiserId: number | null
) => ({
  name: "",
  advertiserId: beeswaxAdvertiserId,
  alternativeId: "",
  active: "inactive",
  notes: null,
  content: targetExpressionModuleDefaultValues(),
});

export const VERB_USAGE_SELECT_LIST = [
  {
    label: "Include",
    value: VERB_USAGE.INCLUDE,
    icon: CheckCircleRoundedIcon,
  },
  {
    label: "Exclude",
    value: VERB_USAGE.EXCLUDE,
    icon: RemoveCircleRoundedIcon,
  },
  {
    label: "Require",
    value: VERB_USAGE.REQUIRE,
    icon: StarsRoundedIcon,
  },
];

export function targetExpressionModuleDefaultValues() {
  return structuredClone(TARGETING_EXPRESSION_MODULES_DEFAULT_VALUES);
}
